import logoWord from 'assets/logo-reverse.svg';
import logo from 'assets/logo512.png';
import { Button } from 'components/Elements';
import { Head } from 'components/Head';
import { useAuth } from 'lib/auth';
import { Box, ChevronRight, Lock } from 'react-feather';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  const handleStart = () => {
    if (user) {
      navigate('/app');
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <>
      <Head title="JustKnow" description="Support" />

      {/* Background Wrapper with Ethnic Image */}
      <div className="min-h-screen flex items-center justify-center p-4 sm:p-6 md:p-10">
        <div className="w-full max-w-8xl h-[90vh] bg-[#383D4E] text-white rounded-2xl shadow-2xl px-6 py-12 flex flex-col justify-between">
          {/* Main Content Centered */}
          <div className="flex flex-col items-center justify-center flex-grow text-center">
            <div className="flex flex-col items-center justify-center mb-6">
              <img src={logo} alt="Justknow" className="h-24 w-24" />
              <img src={logoWord} alt="Justknow" className="h-20 w-auto" />
            </div>
            <p className="text-lg">
              This platform is strictly for the use of authorized and active Justknow support team.
            </p>

            <div className="mt-10 flex justify-center">
              <Button variant="secondary" onClick={handleStart} endIcon={<ChevronRight />}>
                {user ? `Welcome Back ${user.username}` : 'Continue'}
              </Button>
            </div>
          </div>

          {/* Footer - Stuck to Bottom of Container */}
          <div className="mt-10 text-xs text-gray-400 text-center border-t border-gray-600 pt-4 space-y-1">
            <div>© {currentYear} NorthUp Limited. All rights reserved.</div>
            <div>
              JustKnow complies with industry standards for data protection, accessibility, and
              information security. By using this service, you agree to our{' '}
              <a href="/terms" className="underline hover:text-white">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="/privacy" className="underline hover:text-white">
                Privacy Policy
              </a>
              .
            </div>
            <div className="mb-3">
              For questions or legal inquiries, contact{' '}
              <a href="mailto:compliance@northup.go.ug" className="underline hover:text-white">
                compliance@northup.go.ug
              </a>
              .
            </div>
            <div className="">
              <Link to="/health" className="underline">
                API Health
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
